module.exports = __webpack_public_path__ + "img/bgc.693b74a9.png";